// extracted by mini-css-extract-plugin
export default {"titleLayout":"AdminLayout_titleLayout__RxQ46","PulseAnimation":"AdminLayout_PulseAnimation__Vd3rd","blinker":"AdminLayout_blinker__l6xXp"};